var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    _vm._g(
      _vm._b(
        {
          staticClass: "jade-button",
          class: _vm.computedClass,
          attrs: { disabled: _vm.disabled || _vm.loading, type: _vm.type },
        },
        "button",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.loading
        ? _c("jade-spinner", {
            attrs: { color: "current-color", size: _vm.computedIconSize },
          })
        : _c("jade-icon", {
            attrs: {
              color: "current-color",
              use: _vm.icon,
              size: _vm.computedIconSize,
            },
          }),
      _c(
        "jade-text",
        {
          attrs: {
            as: "span",
            color: "current-color",
            weight: "semibold",
            variant: _vm.computedTextVariant,
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }